import React, { Component } from 'react';
import { Button, ButtonToolbar, FormGroup, FormControl, ControlLabel, Modal, Form, HelpBlock } from 'react-bootstrap'
import { Map as LeafletMap, TileLayer, FeatureGroup, Polyline } from 'react-leaflet';
import { EditControl } from 'react-leaflet-draw';
import Select from 'react-select';


export class ProviderLaneActiveForm extends Component {
    constructor(props) {
        super(props);

        let defaultMapCenter = window.defaultMapCenter;
        if (!Array.isArray(defaultMapCenter)) {
            defaultMapCenter = [41.15, -8.61024];
        }

        this.state = {
            center: defaultMapCenter,
            bounds: this.calculateBounds(props.form.obj || {}),
            type: props.form.obj.type || null
        };

        this.customRefs = {
            saveChangesButton: React.createRef()
        };
    }

    // Method to change the status of the map edit control
    onChangeEditMapStatus(bool, callback) {
        if (this.customRefs.saveChangesButton.current) {
            this.customRefs.saveChangesButton.current.disabled(bool);
        }

        if (typeof callback === 'function') {
            callback();
        }
    }

    // Method to calculate map bounds based on lane segments
    calculateBounds(lane) {
        if (!Array.isArray(lane.segments) || lane.segments.length === 0) {
            return [{ lat: 41.80582, lng: -6.75719 }, { lat: 37.10202, lng: -8.67422 }];
        }

        const bounds = lane.segments
            .reduce((output, segment) => output.concat(segment.breakpoints), [])
            .reduce((output, point) => {
                output.minLat = Math.min(output.minLat, point.latitude);
                output.maxLat = Math.max(output.maxLat, point.latitude);
                output.minLong = Math.min(output.minLong, point.longitude);
                output.maxLong = Math.max(output.maxLong, point.longitude);
                return output;
            }, { minLat: 90, maxLat: -90, minLong: 180, maxLong: -180 });

        return [{ lat: bounds.minLat, lng: bounds.minLong }, { lat: bounds.maxLat, lng: bounds.maxLong }];
    }

    // Method to get original polylines from form object
    getOriginalPolylines() {
        const { form } = this.props;
        if (!form || !form.obj || !form.obj.segments) {
            return [];
        }

        return form.obj.segments.map(segment => ({
            id: segment.id,
            positions: segment.breakpoints.map(bp => [bp.latitude, bp.longitude])
        }));
    }

    // Method to handle onChange event of Select component
    handleTypeChange = (selectedOption) => {
        const selectedValue = selectedOption ? selectedOption.value : null;

        this.setState({ type: selectedValue });

        this.props.onSelectValue(selectedValue, 'type', 'lane');
    };

    // Method to render edit control on the map
    renderMapEditControl() {
        return (
            <EditControl
                position='topright'
                draw={{
                    polyline: true,
                    polygon: false,
                    rectangle: false,
                    marker: false,
                    circlemarker: false,
                    circle: false,
                }}
                edit={{
                    remove: true,
                }}
                onDrawStart={() => this.onChangeEditMapStatus(true)}
                onEditStart={() => this.onChangeEditMapStatus(true)}
                onDeleteStart={() => this.onChangeEditMapStatus(true)}
                onDrawStop={() => this.onChangeEditMapStatus(false)}
                onEditStop={() => this.onChangeEditMapStatus(false)}
                onDeleteStop={() => this.onChangeEditMapStatus(false)}
                onCreated={(e) => this.props.onAddSegmentValue(e)}
                onEdited={(e) => this.props.onEditSegmentsValue(e)}
                onDeleted={(e) => this.props.onDeleteSegmentsValue(e)}
            />
        );
    }

    // Method to render original polylines on the map
    renderOriginalPolylines() {
        const originalPolylines = this.getOriginalPolylines();
        if (originalPolylines.length === 0) {
            return null;
        }

        return originalPolylines.map(p => (
            <Polyline positions={p.positions} key={p.id} />
        ));
    }

    render() {
        const { form, show } = this.props;

        if (!form) {
            return null;
        }

        const { bounds, type } = this.state;

        const defaultLaneTypes = [];
        const laneTypeNames = {
            2: "Estacionamento",
            // Add more as needed
        };

        function renderLaneTypeName(type) {
            return laneTypeNames[type] || "Selecione um tipo de micro mobilidade";
        }

        return (
            <Modal show={show}>
                <Modal.Header>
                    <Modal.Title>{form.title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formName" validationState={form.nameInputError}>
                            <ControlLabel>Nome</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.name}
                                placeholder="Introduza o nome"
                                onChange={(e) => this.props.onChangeValue(e, "name")}
                            />
                            {form.nameInputError && <HelpBlock> Este campo não pode estar vazio. </HelpBlock>}
                        </FormGroup>
                        <FormGroup controlId="formDescription">
                            <ControlLabel>Descrição</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.description}
                                placeholder="Introduza a descrição"
                                onChange={(e) => this.props.onChangeValue(e, "description")}
                            />
                        </FormGroup>
                        <FormGroup controlId="formType">
                            <ControlLabel>Tipo</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder='Selecione um tipo de micro mobilidade'
                                value={type !== null ? { value: renderLaneTypeName(type), label: renderLaneTypeName(type) } : null}
                                defaultValue={type !== null ? { value: renderLaneTypeName(type), label: renderLaneTypeName(type) } : defaultLaneTypes}
                                isMulti={false}
                                onChange={this.handleTypeChange}
                                options={[{ value: 2, label: 'Estacionamento' }]}
                            />
                        </FormGroup>
                        <FormGroup controlId="formMap">
                            <LeafletMap className="map-container" bounds={bounds} minZoom={3} maxZoom={18}>
                                <TileLayer
                                    attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                                />
                                <FeatureGroup>
                                    {this.renderMapEditControl()}
                                    {this.renderOriginalPolylines()}
                                </FeatureGroup>
                            </LeafletMap>
                        </FormGroup>
                    </Form>
                    <ButtonToolbar>
                        <RefButton ref={this.customRefs.saveChangesButton} onClick={() => this.props.onSave()}>GUARDAR ALTERAÇÕES</RefButton>
                        <Button onClick={() => this.props.onHide()}>CANCELAR</Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}

class RefButton extends Component {
    constructor(props) {
        super(props);
        this.state = {
            disabled: props.disabled || false
        };
    }

    disabled(bool) {
        this.setState({ disabled: bool });
    }

    render() {
        const { children, onClick } = this.props;
        const { disabled } = this.state;

        return (
            <Button disabled={disabled} onClick={onClick}>
                {children}
            </Button>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/providerLanes/ProviderLaneActiveForm.js